// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const CardGrid = require('client-v2/common/components/card-grid')

const bem = BemEntity('DiscoverSection')

class DiscoverSection extends React.PureComponent {

  renderGrid() {
    return (
      tag(CardGrid, Object.assign({}, this.props, {
        className: bem.element('grid')
      }))
    )
  }

  renderHeader() {
    if (!this.props.isHeaderVisible) {
      return null
    }
    return tag('div', {
      className: bem.element('header', { experiment: 'b' })
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Explore Top Picks on Mix`
      ),
      tag('div', {
        className: bem.element('subheading')
      },
        `Mix shows you content matched to your interests,\n`,
        `recommended by friends and community experts.`
      )
    )
  }

  renderMoreButton() {
    if (!this.props.isMoreAvailable) {
      return null
    }
    return (
      tag('button', {
        className: bem.element('button'),
        onClick: this.props.onMoreClick
      },
        `Load more`
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        this.renderHeader(),
        this.renderGrid(),
        this.renderMoreButton()
      )
    )
  }
}

DiscoverSection.propTypes = {
  // Flags
  isHeaderVisible: PropTypes.bool,
  isMoreAvailable: PropTypes.bool,
  // Callbacks
  onMoreClick: PropTypes.func
}

module.exports = DiscoverSection
